module.exports = function getResource (label, vars = []) {
    let resources = {
        estimatedOrderTotal: 'Total estimé',
        orderTotal: 'Total de la commande',
        merchandiseSubtotal: 'Sous-total des marchandises',
        pointsUsed: 'Points utilisés',
        shippingAndHandling: 'Expédition et manutention',
        discounts: 'Réductions',
        giftWrap: 'Emballage-cadeau',
        gstOrHst: 'TPS/TVH',
        estimatedGstOrHst: 'TPS/TVH estimées',
        pst: 'TVP',
        estimatedPst: 'TVP estimée',
        tax: 'Taxe',
        estimatedTax: 'Taxes estimées',
        storeCreditRedeemed: 'Crédit au compte',
        giftCardRedeemed: 'Carte-cadeau utilisée',
        eGiftCardRedeemed: 'Carte-cadeau électronique utilisée',
        creditCardPayment: 'Paiement par carte de crédit',
        payPalPayment: 'Paiement PayPal',
        viewOrCancel: 'Pour consulter ou annuler votre commande, rendez-vous sur',
        orderDetails: 'détails de la commande',
        pickup: 'Ramassage',
        free: 'GRATUIT'
    };

    return resources[label];
};
